import PropTypes from 'prop-types';
import './Checkbox.css';

export default function Checkbox({
  checked,
  indeterminate,
  onChange,
  disabled = false,
  'aria-label': ariaLabel,
  'aria-required': ariaRequired,
}) {
  const cls = ['ck', checked ? 'on' : '', indeterminate ? 'indeterminate' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      aria-label={ariaLabel}
      aria-required={ariaRequired}
      className={cls}
      onClick={disabled ? undefined : onChange}
      disabled={disabled}
      data-testid="checkbox"
    />
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string,
  'aria-required': PropTypes.bool,
};
